import { ASSETS_BASE_URL } from '@/config';
import { Route } from '@/constants';
import { useCompanyRole } from '@/features/company/hooks';
import { useLogout } from '@/features/auth';
import { useGetCurrentUserQuery } from '@/features/users';

import { useSidebar } from '@/components/ui/sidebar';
import type { AvatarDropdownItem } from '@/features/header/components/avatar-dropdown';
import { NavUserView, type NavUserInfo } from '@/components/nav-user-view';

export type AvatarDropdownProps = {
  readonly options: AvatarDropdownItem[];
};

export function NavUser({ options }: AvatarDropdownProps) {
  const { isMobile } = useSidebar();

  const { data: user } = useGetCurrentUserQuery();
  const { isFree } = useCompanyRole();
  const logout = useLogout();

  const userFirstName = user?.first_name ?? 'Anonymous';
  const userLastName = user?.last_name ?? 'User';
  const companyName = user?.company?.name ?? 'Company';

  const userInfo: NavUserInfo = {
    firstName: userFirstName,
    lastName: userLastName,
    fullName: `${user?.first_name ?? userFirstName} ${userLastName}`,
    avatar: user?.avatar ? `${ASSETS_BASE_URL}/${user.avatar}` : '',
    email: user?.email || '',
    company: companyName,
  };

  return (
    <NavUserView
      options={options}
      userInfo={userInfo}
      dropdownSide={isMobile ? 'bottom' : 'right'}
      showUpgrade={isFree}
      upgradeToProHref={Route.PlanSettings}
      onLogout={logout}
    />
  );
}
